
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.298 5.457a.857.857 0 00-1.212 1.212l2.845 2.845H2a.857.857 0 000 1.714h13.93l-2.844 2.844a.857.857 0 001.212 1.212l4.3-4.3a.87.87 0 00.166-.223.854.854 0 00-.159-.997l-4.307-4.307z","fill":"currentColor"}})])
          )
        }
      }
    